import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { canUserSeeCase, delegateCase, fetchCaseModerators } from 'app/edozvola/cases/cases-service';
import { ERRORS, messages } from 'app/config/constants';
import { toast } from 'react-toastify';
import {queryClient} from "app/app";

export interface ICaseDelegationProps {
  idCase: string;
  idSolverCosolver: number;
}

export const delegateCaseQuery = closeDelegationModal => {
  return useMutation({
    mutationFn: (caseDelegationProps: ICaseDelegationProps) => {
      return delegateCase(caseDelegationProps.idCase, caseDelegationProps.idSolverCosolver).finally(closeDelegationModal());
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['cases']});
      showToast(toast.success, messages.CASE_DELEGATED);
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

export const fetchCaseModeratorsQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['moderators', idCase],
    queryFn: ({ signal }) => fetchCaseModerators(idCase),
  });
};

export const canUserSeeCaseQuery = (uuid: string, account: any) => {
  return useQuery({
    queryKey: ['case-permission', { uuid: uuid, account: account }],
    queryFn: () => canUserSeeCase(uuid),
    enabled: !!uuid && !!account && account.firstName !== 'ROLE_NEPRIJAVLJENI',
  });
}

